import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-plus\"><rect x=\".5\" y=\".5\" width=\"35\" height=\"35\" rx=\"1.5\" stroke=\"currentColor\" /><path d=\"M14 18.452v-.882h3.496V14h1.008v3.57H22v.882h-3.496V22h-1.008v-3.548H14Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol